import React from "react";

const SorterSVG = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="4" fill="white"/>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L7 9.58579V4C7 3.44771 7.44772 3 8 3C8.55228 3 9 3.44771 9 4V9.58579L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L8.70711 12.7071Z"
        fill="#969FA8"
      />
    </svg>
  )
};

export default SorterSVG;
